import { render, staticRenderFns } from "./ShipmentsFilter.vue?vue&type=template&id=11d43a4e"
import script from "./ShipmentsFilter.vue?vue&type=script&lang=js"
export * from "./ShipmentsFilter.vue?vue&type=script&lang=js"
import style0 from "./ShipmentsFilter.vue?vue&type=style&index=0&id=11d43a4e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports